export const APPLICANTS_VIEW_PARAM = 'view'
